import axios from 'axios';
import Vue from 'vue'
import Vuex from 'vuex'
import WebSocketService from '@/utils/socket';
Vue.use(Vuex)

export default new Vuex.Store({

  state: {

    adminMenus: [],

    accessToken: localStorage.getItem('accessToken') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    userName: localStorage.getItem('userName') || '',
    userId: localStorage.getItem('userId') || '',
    roleId:localStorage.getItem('roleId') || '',
    userRoleId:localStorage.getItem('userRoleId') || '',

    showNotification: false ,
    showNoticetion: false,
    notifications: null,// 或者初始化为某个特定的值，比如 0 或空数组 []
    
    notify:null,

    // 2025年5月27日10:08:58,测试全局数字动态添加
    notificationCounter:0,   // 初始值为0

    // 2025年9月11日10:48:45,新增状态值
    receiveCounter: 0,

    receiveNotifications: null,// 或者初始化为某个特定的值，比如 0 或空数组 []

    // 2025年6月7日15:20:13
    currentMenu: '', // 初始化为空字符串或默认菜单项

    userInfo: {
      userId: '',
      userName: '',
      messageObject: {}
    },

    

    refreshFlag: 0,

    noticeStatus:null,

    readStatusInfo: '',

    currentEngineerId:null,

    changeEngineerId:null,
    
    // 用来触发在同一组件中状态值的变化
    changeEngineerCounter:0
  },


  mutations: {

    SET_ENGINEER_ID(state, id) {

      state.currentEngineerId = id

      localStorage.setItem('currentEngineerId',JSON.stringify(state.currentEngineerId));
    },

    SET_CHANGE_ID(state, id){
      console.log('change变化的id', id);

      state.changeEngineerCounter = (state.changeEngineerCounter + 1) % 11;

      console.log('changeEngineerCounter变化的id', state.changeEngineerCounter);

      state.changeEngineerId = id

      localStorage.setItem('changeEngineerId',JSON.stringify(state.changeEngineerId));
    },

    CLEAR_ENGINEER_ID(state) {
      state.currentEngineerId = null;
    },

    CLEAR_CHANGE_ID(state){
      state.changeEngineerId = null;
    },

    // 1.状态值自动累加
    incrementNotificationCounter(state) {
      // 当达到10时，+1后取模11会得到0
      state.notificationCounter = (state.notificationCounter + 1) % 11;
    },

    receiveCounterAdd(state){
      state.receiveCounter = (state.receiveCounter + 1) % 11;
    },

    // 2.更新全局消息校验状态
    showNotification(state, value) {  
      state.showNotification = value;  
    } , 

    // 3.更新全局公告通知
    showNoticetion(state, value){
      state.showNoticetion = value;  
    },

    setShowNoticetion(state, value) {
      state.showNoticetion = value
    },

    // 3.初始化菜单
    initAdminMenu (state, menus) {
      state.adminMenus = menus;
    },
    
    // 4.将登录方法的信息分别保存到 Vue Store、浏览器的localStorge当中
    login (state, user) {
      
      // 1.将 token 信息保存到 Vue Store当中, accessToken：是登录成功的token; refreshToken: 是 accessToken 过期之后,用户刷新的token。
      state.accessToken = user.accessToken;

      state.refreshToken = user.refreshToken;

      state.userId = user.userId;

      state.userName = user.userName;
      

      state.userRoleId = user.userRoleId;

      state.userInfo.userId = user.userId;

      state.userInfo.userName = user.userName;

      // 判断当前角色是否在该条公告通知公告内
      state.noticeStatus = user.noticeStatus;
      
      // 判断公告是否已经进行阅读
      state.readStatusInfo = user.readStatusInfo;

      localStorage.setItem('noticeStatus',JSON.stringify(user.noticeStatus));

      localStorage.setItem('userId',JSON.stringify(user.userId));

      localStorage.setItem('readStatusInfo',JSON.stringify(user.readStatusInfo));

      localStorage.setItem('accessToken',JSON.stringify(user.accessToken));

      localStorage.setItem('refreshToken',JSON.stringify(user.refreshToken));

      localStorage.setItem('userName',JSON.stringify(user.userName));


      localStorage.setItem('userRoleId',JSON.stringify(user.userRoleId));
    },


    // 5.退出方法,注意不能使用 null清除，否则无法判断 user里具体的内容
    logout (state) {

      state.accessToken = '';
      state.refreshToken = '';
      state.userName = '';
      state.userId = '';

      window.localStorage.removeItem('accessToken');
      window.localStorage.removeItem('refreshToken');

      window.localStorage.removeItem('userId');
      window.localStorage.removeItem('userName');

      window.localStorage.removeItem('activeMenu');

      window.localStorage.removeItem('noticeStatus');

      window.localStorage.removeItem('readStatusInfo');

      window.localStorage.removeItem('roleId');
      
      state.adminMenus = []
    },


    // 6.更新token的mutation  
    updateToken(state, tokenInfo) {


      state.accessToken = '';

      state.refreshToken = '';
      
      window.localStorage.removeItem('accessToken');
      window.localStorage.removeItem('refreshToken');

      state.accessToken = tokenInfo.data.data.accessToken;
      state.refreshToken = tokenInfo.data.data.refreshToken;

      window.localStorage.setItem('accessToken', JSON.stringify(state.accessToken)); // 更新localStorage中的token
      window.localStorage.setItem('refreshToken', JSON.stringify(state.refreshToken)); // 更新localStorage中的token 
    }, 

    // 7.更新 加载状态
    setLoading(state, isLoading) {  
      state.isLoading = isLoading;  
    },

    // 8.更新 notifycation状态值,这里也是一个函数
    set_notifications(state, notifycation){
      state.notifications = notifycation;
    },

    set_receivecations(state, receiveNum){
      state.receiveNotifications = receiveNum;
    },


    // 9.更新消息信息
    add_message(state, message){

      const fromId = message.fromId;

      const key = `user${fromId}`;

      // 添加判断条件
      if(!state.userInfo.messageObject[key]){
        // 初始化该用户的消息数组
        Vue.set(state.userInfo.messageObject, key, [])
      }else {
        // 将消息添加到该用户的消息数组中
        state.userInfo.messageObject[key].push(message);
      }

      // 将对象放到localStore当中
      window.localStorage.setItem('userInfo',JSON.stringify(state.userInfo));

    },

    // 10.消息提醒
    setNotify(state,message){
      state.notify = message
    },


    // 11.2025年6月7日15:18:59,添加一个菜单高亮的效果
    setCurrentMenu(state, menuPath){
      state.currentMenu = menuPath;
    },

    // // 12.更新token方法
    SET_RETRY_DATA(state) {
      state.refreshFlag = (state.refreshFlag + 1) % 10  // 自动循环0-10
    },


    // 13.提交消息内容
    send_message(state, message){

      // 把消息发送给谁
      const toId = message.toId;

      const key = `user${toId}`;

      // 检查 messageObject[key] 是否存在且为数组
      if(!state.userInfo.messageObject[key] || !Array.isArray(state.userInfo.messageObject[key])){
        state.userInfo.messageObject[key] = [];
      }
      state.userInfo.messageObject[key].push(message);
    },
  },


  // actions:对象
  actions: {  
    
    async  userLogin({ commit }, userCredentials){

      try {

        const response = await axios.post('/admin/userLogin', userCredentials);

        if(response && response.data.code === 200){
          
          const tokenInfo = response.data.data;

          // 1.调用 mutation 来更新登录状态
          commit('login',tokenInfo);

          // 2.更新notifycation消息通知.
          commit('showNotification', true);

          // 3.新加一个公告通知,用来通知全局提醒
          commit('showNoticetion',true);

          // 初始化 WebSocket 连接
          initWebSocketConnection(tokenInfo);
        }
      }catch(error){
        error.message = '账号或密码输入错误,请检查后重新输入登录'
        return Promise.reject(error)
      }
    },

    // 定义之后，这里是一个函数,然后在里面有一个 commit
    addNotification({ commit }, notification) {
      commit('set_notifications', notification);
    },

    // 回复消息状态值
    ReceiveNotification({commit}, receiveNum){
      console.log('回复的状态值', receiveNum)
      commit('set_receivecations', receiveNum);
    },

    // 处理接收聊天
    receiveWebsocketMessage({ commit }, message) {
      const dataObj = JSON.parse(message);

      console.log('接收到服务器返回的消息数据信息', dataObj)


      // 添加一条消息提醒
      commit('setNotify',message);

      commit('add_message', dataObj);
    },

    // 发送消息处理
    sendMessage({ commit }, message){

      // 提交消息
      commit('send_message', message);

      const useInfoString = JSON.stringify(this.state.userInfo);

      localStorage.setItem('userInfo', useInfoString);
    },

    // 计数器累加
    updateCounter({ commit }) {
      commit('incrementNotificationCounter')
    },

    // 消息接收时的一套逻辑
    updateReceiveCounter({commit}){
      commit('receiveCounterAdd')
    },

    updateCurrentMenu({commit}, menuPath){
      console.log(menuPath);
      commit('setCurrentMenu', menuPath);
    },
    
    // 不同组件跳转
    setEngineerId({ commit }, id) {
      
      commit('SET_ENGINEER_ID', id)
    },

    // 同一组件跳转
    changeEngineerId({ commit }, id) {
      commit('SET_CHANGE_ID', id)
    },

    clearEngineerId({ commit }) {
      commit('CLEAR_ENGINEER_ID');
    },

    clearChangeEngineerId({ commit }){
      commit('CLEAR_CHANGE_ID');
    }
  },


  getters: {
    getUserId: state => state.userId,
    currentCounter: state => state.notificationCounter,
    receiveCounterInfo: state => state.receiveCounter,
    changeEngineerCounter: state => state.changeEngineerCounter,

    // 创建一个 getter 来根据 userId 从 userInfo.messageObject 中获取消息
    getMessageObj: state => state.userInfo.messageObject,

    getReceiveMessageObj: state => state.receiveInfo.messageObject
  },
})



// 辅助函数：初始化 WebSocket 连接
function initWebSocketConnection(tokenInfo){
  const userId = tokenInfo.userId;

  // 本地的websocket地址信息
  const wsUrl = `ws://localhost:8843/api/websocket/${userId}`

  // 服务器的websocket地址信息
  // const wsUrl = `wss://www.dxzxip.com/api/websocket/${userId}`

  WebSocketService.connect(wsUrl);
}
